export function isSuperAdminUser (user) {
  return Number(user && user.usertype) === 1
}



// WEBPACK FOOTER //
// ./src/views/training/training-user.js